export enum AlertThresholdOperator {
  Equals = 'Equals',
  LessThan = 'Less Than',
  GreaterThan = 'Greater Than',
}
